import React from 'react'

const GoogleIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'>
      <g clip-path='url(#clip0_23072_23341)'>
        <path
          d='M5.57338 0.526614C3.97473 1.0812 2.59606 2.13382 1.63987 3.52987C0.683675 4.92591 0.200366 6.59179 0.26093 8.28282C0.321493 9.97385 0.922737 11.6009 1.97635 12.925C3.02996 14.249 4.4804 15.2003 6.11463 15.6391C7.43953 15.981 8.82764 15.996 10.1596 15.6829C11.3663 15.4118 12.4819 14.8321 13.3971 14.0004C14.3497 13.1083 15.0412 11.9735 15.3971 10.7179C15.784 9.35245 15.8529 7.91653 15.5984 6.52036H8.15838V9.60661H12.4671C12.381 10.0988 12.1965 10.5687 11.9246 10.9879C11.6527 11.4072 11.299 11.7672 10.8846 12.0466C10.3585 12.3947 9.76537 12.6288 9.14338 12.7341C8.51956 12.8501 7.8797 12.8501 7.25588 12.7341C6.62361 12.6034 6.0255 12.3424 5.49963 11.9679C4.65481 11.3698 4.02047 10.5203 3.68713 9.54036C3.34815 8.54211 3.34815 7.45987 3.68713 6.46161C3.92441 5.76188 4.31667 5.12478 4.83463 4.59786C5.42737 3.9838 6.17779 3.54486 7.00357 3.32921C7.82935 3.11356 8.69858 3.12953 9.51588 3.37536C10.1543 3.57135 10.7382 3.91379 11.2209 4.37536C11.7067 3.89203 12.1917 3.40745 12.6759 2.92161C12.9259 2.66036 13.1984 2.41161 13.4446 2.14411C12.7078 1.45846 11.843 0.924935 10.8996 0.574114C9.18176 -0.0496489 7.3021 -0.0664119 5.57338 0.526614Z'
          fill='white'
        />
        <path
          d='M5.57445 0.527221C7.30303 -0.0662075 9.18269 -0.0498857 10.9007 0.573471C11.8442 0.926676 12.7087 1.46277 13.4445 2.15097C13.1945 2.41847 12.9307 2.66847 12.6757 2.92847C12.1907 3.41264 11.7061 3.89514 11.222 4.37597C10.7393 3.91439 10.1554 3.57196 9.51695 3.37597C8.69992 3.12927 7.83073 3.11238 7.00473 3.32715C6.17873 3.54192 5.42784 3.98005 4.83445 4.59347C4.31649 5.12039 3.92424 5.75749 3.68695 6.45722L1.0957 4.45097C2.02321 2.61167 3.62914 1.20475 5.57445 0.527221Z'
          fill='#E33629'
        />
        <path
          d='M0.40695 6.43672C0.546226 5.74646 0.777454 5.078 1.09445 4.44922L3.6857 6.46047C3.34672 7.45873 3.34672 8.54096 3.6857 9.53922C2.82237 10.2059 1.95862 10.8759 1.09445 11.5492C0.300888 9.96961 0.0588654 8.16985 0.40695 6.43672Z'
          fill='#F8BD00'
        />
        <path
          d='M8.15876 6.51953H15.5988C15.8533 7.9157 15.7844 9.35162 15.3975 10.717C15.0416 11.9726 14.3501 13.1075 13.3975 13.9995C12.5613 13.347 11.7213 12.6995 10.885 12.047C11.2996 11.7674 11.6535 11.4069 11.9254 10.9872C12.1973 10.5675 12.3817 10.0972 12.4675 9.60453H8.15876C8.15751 8.57703 8.15876 7.54828 8.15876 6.51953Z'
          fill='#587DBD'
        />
        <path
          d='M1.09375 11.5491C1.95792 10.8824 2.82167 10.2124 3.685 9.53906C4.01901 10.5193 4.65426 11.3689 5.5 11.9666C6.02751 12.3394 6.62691 12.5982 7.26 12.7266C7.88382 12.8426 8.52368 12.8426 9.1475 12.7266C9.7695 12.6213 10.3626 12.3871 10.8888 12.0391C11.725 12.6916 12.565 13.3391 13.4013 13.9916C12.4861 14.8237 11.3705 15.4039 10.1638 15.6753C8.83176 15.9884 7.44366 15.9734 6.11875 15.6316C5.07088 15.3518 4.09209 14.8586 3.24375 14.1828C2.34583 13.4699 1.61244 12.5715 1.09375 11.5491Z'
          fill='#319F43'
        />
      </g>
      <defs>
        <clipPath id='clip0_23072_23341'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GoogleIcon
